import { all, fork } from 'redux-saga/effects';

import { applicationMux } from './application';
import authSaga from './application/auth/auth.saga';
import { configurationsSaga } from './configurations/configurations.saga';
import environmentSaga from './environment/environment.saga';

export default function* rootSaga() {
  yield all([fork(applicationMux)]);
  yield all([fork(configurationsSaga)]);
  yield all([fork(authSaga)]);
  yield all([fork(environmentSaga)]);
}
